import { useContext } from 'react';

import { SignFormContext } from '#src/app/pages/petitionDetails/shared/contexts';

export function useSignFormInsideMobileModal(): boolean {
	const context = useContext(SignFormContext);
	return !!context?.insideMobileModal;
}
